import { StateEffect, StateField } from '@codemirror/state';

type FilePathState = string | null;

export const updateFilePath = StateEffect.define<FilePathState>();

export const filePathStateField = StateField.define<FilePathState>({
  create: () => null,
  update(value, transaction) {
    for (const effect of transaction.effects) {
      if (effect.is(updateFilePath)) {
        return effect.value;
      }
    }

    return value;
  },
});
